<template>
    <div class="timeout-enter-email__container">
        <Banner/>
        <div class="timeout-enter-email__content-container">
            <div class="divider-2" />
            <HeaderFourBenton value="You have been logged out." />  
            <div class="divider-1" />
            <InstructionLabel  :value="`Click the 'Return to Login' button below and return to Advisor when you're ready.`" />
            <div class="divider-2" />
            <v-form ref="form" lazy-validation>
                <div class="timeout-enter-email__content">
                    <div class="timeout-enter-email__interaction-divider">
                        <v-divider class="timeout-enter-email__interaction-divider"></v-divider>
                    </div>
                    <SecondaryButton
                        text="Return to Login"
                        :loading="isProcessing"
                        @btnClick="onReturnToLoginClicked" 
                        outlined
                    />
                    <div class="divider-3" />
                </div>
            </v-form>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import {MAIN_ACT_LOGOUT} from "@/store/types";
import HeaderFourBenton from "@/components/Typographical/Header/Header-four";
import InstructionLabel from "@/components/Typographical/Label/index.vue"
import SecondaryButton from "@/components/Buttons/Secondary";
import Banner from "@/components/Branding/banner";
import {OKTA_LOGOUT_URL} from "@/env";

export default {
    components: {
        Banner,
        HeaderFourBenton,
        InstructionLabel,
        SecondaryButton,
    },
    props: {
        isProcessing: { type: Boolean, default: false },
    },
    methods: {
        ...mapActions({
            logout: "main/" + MAIN_ACT_LOGOUT,
        }),
        onReturnToLoginClicked() {
            location.replace(OKTA_LOGOUT_URL)
        },
    },
}
</script>

<style lang="scss" scoped>
    .timeout-enter-email__container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
    .timeout-enter-email__content-container {
        width: 500px;
    }
    .timeout-enter-email__interaction-divider {
        display: flex;
        align-items: center;
        width: 100%;
        margin: 12px 0;
    }
    .timeout-enter-email__interaction-divider {
        margin-right: 10px;
                margin-left: 10px;
    }
    .divider-1 {
        margin-top: 12px;
    }
    .divider-2 {
        margin-top: 24px;
    }
    .divider-3 {
        margin-top: 12px;
    }
</style>
